import React, { CSSProperties } from "react";

/**
 * Full-screen message shown instead of the call when a person cannot join.
 *
 * Extracted verbatim from the wrong-account card that was inline in
 * Interviewer.tsx, so every "you can't be in this call" state now renders the
 * same way — including "Room Full", which was previously a bare `return "Room
 * Full"` string with no styling at all.
 */
type InterviewNoticeProps = {
  title: string;
  children?: React.ReactNode;
  /** Optional action, e.g. a login button. */
  action?: React.ReactNode;
};

export default function InterviewNotice(props: InterviewNoticeProps) {
  const { title, children, action } = props;
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.title}>{title}</div>
        {typeof children === "string" ? (
          <p style={styles.text}>{children}</p>
        ) : (
          children
        )}
        {action}
      </div>
    </div>
  );
}

export const noticeTextStyle: CSSProperties = {
  fontSize: 15,
  lineHeight: 1.5,
  marginBottom: 20,
  color: "#333",
};

const styles: Record<string, CSSProperties> = {
  wrap: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#999999",
  },
  card: {
    background: "white",
    borderRadius: 12,
    padding: 32,
    maxWidth: 440,
    boxShadow: "0 2px 12px rgba(0,0,0,0.2)",
    textAlign: "center",
  },
  title: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 12,
  },
  text: noticeTextStyle,
};
